import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '../../../../../node_modules/@angular/router';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { CacheService } from '../../../shared/services/cache.service';
import { PaymentProcessorAlias } from '../../enums/payment-processor-alias.enum';
import { PaymentStatus } from '../../enums/payment-status.enum';

@Component({
    selector: 'app-payment-status',
    templateUrl: '../../templates/template1/views/payments/payment-status.component.html',
    styleUrls: []
})

export class PaymentStatusComponent implements OnInit {

    constructor(
        private _router: Router,
        private _cacheService: CacheService,
        private _activatedRoute: ActivatedRoute) { }

    ngOnInit(): void {
        this.loadDefaultSettings();
    }

    /**
     * @description Load Default shipping Settings
     * for the current user
     * @date 2018-07-20
     * @memberof PaymentComponent
     */
    loadDefaultSettings() {
        this._activatedRoute.params.subscribe(params => {
            const queryParams: Params = this._activatedRoute.snapshot.queryParams;
            if (queryParams) {
                this.storePaymentDetails(queryParams);
            }
            this.navigateBasedOnStatus(params);
        });
    }

    /**
     * @description Store Payment details
     * @date 2018-11-16
     * @param {Params} queryParams
     * @memberof PaymentStatusComponent
     */
    storePaymentDetails(queryParams: Params): void {
        const paymentInstrumentId = queryParams['customerTokenId'] || queryParams['customertokenid'];
        if (paymentInstrumentId && paymentInstrumentId !== 'null') {
            this._cacheService.set('PaymentInstrumentId', +paymentInstrumentId);
        }
    }

    /**
     * @description this method will help to navigate
     * to payment section or order summary section based on payment status
     * @date 2018-08-13
     * @private
     * @param {Params} params
     * @memberof PaymentStatusComponent
     */
    private navigateBasedOnStatus(params: Params) {
        sessionStorage.removeItem(CacheKey.posOrderPaymentStatus);
        const processor: PaymentProcessorAlias = params['paymentProcessor'];
        const paymentStatus = params['paymentStatus'];
        const updateOrderInfo = this._cacheService.get('UpdateOrderInfo');
        const routeURL = window.location.href.includes('posorders') ? '/customerservice/posorders' : '/customerservice/orders';
        sessionStorage.setItem(CacheKey.posOrderPaymentStatus,paymentStatus);
        if (updateOrderInfo) {
            if (updateOrderInfo.webOrderId && paymentStatus.toUpperCase() === PaymentStatus.SUCCESS) {
                this._router.navigateByUrl(routeURL + '/' + updateOrderInfo.webOrderId);
            } else {
                this._router.navigateByUrl(routeURL + '/' + updateOrderInfo.webOrderId);
            }
        } else {
            if(paymentStatus && paymentStatus === PaymentStatus.FAILED.toLowerCase()){
                this._cacheService.set(CacheKey.PaymentStatus, paymentStatus);
                this._cacheService.remove(CacheKey.PaymentInstrumentId);
                }
            this._router.navigateByUrl(routeURL);
        }
    }

    /**
     * @description this method will navigate
     * @date 2018-08-14
     * @private
     * @param {CheckoutInformation} checkoutInformation
     * @memberof PaymentStatusComponent
     */
    // private routeNavigation(checkoutInformation: CheckoutInformation): void {
    //     const orderDetails: Order = checkoutInformation.orderDetails;
    //     const enrollInfo: EnrollInfo = checkoutInformation.enrollInformation;
    //     let routerUrl = '';
    //     if (this.psComponentSettings.userInfo) {
    //         routerUrl = '/checkout/ordersummary/' + orderDetails.webOrderId;
    //     } else if (enrollInfo && enrollInfo.personalInfo && enrollInfo.personalInfo.memberId) {
    //         routerUrl = '/checkout/member/ordersummary/' + enrollInfo.personalInfo.memberId;
    //     }
    //     this._router.navigateByUrl('/' + this.psComponentSettings.isoCountryCode.toLowerCase() + '/'
    //         + this.psComponentSettings.languageCode.toLowerCase() + routerUrl);
    // }


    /**
     * @description this method will load member type
     * or logeed in member information
     * @date 2018-07-25
     * @private
     * @memberof PaymentComponent
     */
    // private loadMemberType(): void {
    //     this.psComponentSettings.userInfo = this._cacheService.get(CacheKey.UserInfo);
    //     this.psComponentSettings.registerMemberType = this.psComponentSettings.userInfo
    //         && this.psComponentSettings.userInfo.memberTypeId
    //         ? this.psComponentSettings.userInfo.memberTypeId : this._cacheService.get(CacheKey.RegisterMemberType);
    // }


    /**
    * @description this method retives
    * store information from cache service
    * @date 2018-07-19
    * @memberof PaymentComponent
    */
    // private getStoreData(): void {
    //     const result: StoreConfig = this._configurationService.getStoreData();
    //     if (result) {
    //         this.psComponentSettings.store = result;
    //     }
    // }


    /**
    * @description this method is used
    * load stored information while refreshing the page
    * @date 2018-07-21
    * @memberof PaymentComponent
    */
    // private loadCheckoutInformation(): void {
    //     this.psComponentSettings.checkoutInformation = this._cacheService.get(CacheKey.CheckoutInformation);
    // }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/payments/payment-status.component.ts